import React from "react";
import classes from "./styles.module.scss";
import { Link } from "react-router-dom";
const Copyright = () => {
  return (
    <div className={classes.copyright_wrapper}>
      <div className={classes.copyright_container}>
        <div className={classes.copyright_left}>
          © 2026 Gyandeep All Right Reserved By{" "}
          <Link
            to="https://education.bihar.gov.in/"
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link_text}
          >
            Education Department Bihar
          </Link>
        </div>
        <div className={classes.copyright_right}>
          <Link
            to="https://codebuckets.in/"
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link_text}
          >
            Designed & Developed by Codebucket Solutions
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Copyright;
